import { render, staticRenderFns } from "./BeneficiaryFormTypes.vue?vue&type=template&id=062becdc&"
import script from "./BeneficiaryFormTypes.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryFormTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports